import React from 'react';
import NavBarAttendant from '../components/nav/navbar-attendant.js';
import AuthCheck from '../components/auth-check.js';
import EquipmentServiceRequest from '../components/equipment/equipment-service-request.js';
import MountAtPageTop from '../components/utility/mount-at-page-top.js';
import setTitle from '../decorators/set-title.js';

export class EquipmentServiceRequestRoute extends React.PureComponent {
  render() {
    return (
      <div className="">
        <AuthCheck />
        <MountAtPageTop />
        <NavBarAttendant />
        <div className="variable-width-column">
          <EquipmentServiceRequest />
        </div>
      </div>
    );
  }
}

EquipmentServiceRequestRoute = setTitle(() => {
  return 'Equipment Service Request';
})(EquipmentServiceRequestRoute);

export default EquipmentServiceRequestRoute;
